import { z } from 'zod'

export const CancelOrderParamsSchema = z.object({
  orderId: z.string(),
  recommendationId: z.string(),
  bundleId: z.string(),
})

export type CancelOrderParams = z.infer<typeof CancelOrderParamsSchema>
